import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\">\n<path d=\"M11.0003 6.83366H6.83366V11.0003C6.83366 11.4587 6.45866 11.8337 6.00033 11.8337C5.54199 11.8337 5.16699 11.4587 5.16699 11.0003V6.83366H1.00033C0.541992 6.83366 0.166992 6.45866 0.166992 6.00033C0.166992 5.54199 0.541992 5.16699 1.00033 5.16699H5.16699V1.00033C5.16699 0.541992 5.54199 0.166992 6.00033 0.166992C6.45866 0.166992 6.83366 0.541992 6.83366 1.00033V5.16699H11.0003C11.4587 5.16699 11.8337 5.54199 11.8337 6.00033C11.8337 6.45866 11.4587 6.83366 11.0003 6.83366Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/add.svg
// module id = EbzB
// module chunks = 13